import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" id=\"user\"><path d=\"M18.5 16.56c0-.943-.61-1.744-1.456-2.027-.066-.023-4.398-1.13-5.018-2.36-.283-.563-.004-1.283.278-1.78.13-.174.256-.358.377-.551.734-1.175 1.294-2.72 1.351-4.63C14.118 2.34 11.895.007 9.257 0 6.606.007 4.383 2.34 4.469 5.212c.057 1.91.617 3.455 1.35 4.629.122.194.249.378.378.552.282.497.561 1.217.278 1.78-.619 1.23-4.952 2.337-5.018 2.36A2.138 2.138 0 0 0 0 16.56v1.94h18.5v-1.94z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/user.svg
// module id = ./src/assets/icons/user.svg
// module chunks = 2